<form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">

    <nav class="toolbar navbar navbar-light">
        <div class="form-inline">
            <button class="btnback btn btn-outline-success" type="button" title="Volver" (click)="onBack()"><i class="fa fa-chevron-left"></i></button>
            <button type="submit" class="btn btn-outline-success" title="Guardar"><i class="fa fa-save"></i> Guardar</button>
        </div>
    </nav>

    <div class="animated fadeIn container-fluid">

        <h4>{{editTitle}} Tipo de Documentación</h4>

        <div class="row">
            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">

                    <div class="card-body">

                        <div class="row">

                            <div class="form-group col-md-4">
                                <label class="col-form-label" for="inpTipo">Tipo de Solicitud</label>
                                <ng-select [items]="listTipoSolicitud"
                                           bindLabel="Descripcion"
                                           bindValue="Id"
                                           formControlName="IdTipoSolicitud"
                                           loadingText="Cargando..."
                                           [readonly]="!listTipoSolicitud || listTipoSolicitud.length === 0"
                                           [loading]="!listTipoSolicitud || listTipoSolicitud.length === 0"
                                           notFoundText="Tipo no encontrado"
                                           placeholder="-- Seleccione un Tipo --"
                                           clearAllText="Eliminar selección">

                                    <ng-template ng-label-tmp let-item="item">
                                        <img src="/assets/images/TipoSolicitud/{{item.Id}}.png" style="width:24px;vertical-align:middle" />
                                        <span style="vertical-align:middle; margin-left: .5em">{{item.Descripcion}}</span>
                                    </ng-template>
                                    <ng-template ng-option-tmp let-item="item" let-index="index">
                                        <img src="/assets/images/TipoSolicitud/{{item.Id}}.png" style="width:24px;vertical-align:middle" />
                                        <span style="vertical-align:middle; margin-left: .5em">{{item.Descripcion}}</span>
                                    </ng-template>
                                </ng-select>
                            </div>

                            <div class="form-group col-md-2">
                                <label class="col-form-label" for="inpRequerirTexto">Requiere Texto</label>
                                <p-toggleButton class="form-control-togglebutton" formControlName="RequerirTexto"
                                                onLabel="Sí" offLabel="NO" onIcon="pi pi-check"
                                                offIcon="pi pi-times"></p-toggleButton>
                            </div>

                            <div class="form-group col-md-2">
                                <label class="col-form-label" for="inpRequerirFecha">Requiere Fecha</label>
                                <p-toggleButton class="form-control-togglebutton" formControlName="RequerirFecha"
                                                onLabel="Sí" offLabel="NO" onIcon="pi pi-check"
                                                offIcon="pi pi-times"></p-toggleButton>
                            </div>

                            <div class="form-group col-md-2">
                                <label class="col-form-label" for="inpRequerirPais">Requiere País</label>
                                <p-toggleButton class="form-control-togglebutton" formControlName="RequerirPais"
                                                onLabel="Sí" offLabel="NO" onIcon="pi pi-check"
                                                offIcon="pi pi-times"></p-toggleButton>
                            </div>

                            <div class="form-group col-md-2">
                                <label class="col-form-label" for="inpAttachedTraces">Adjuntar Traces</label>
                                <p-toggleButton class="form-control-togglebutton" formControlName="AttachedTraces"
                                                onLabel="Sí" offLabel="NO" onIcon="pi pi-check"
                                                offIcon="pi pi-times"></p-toggleButton>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="col-form-label" for="inpActivo">Activo</label>
                                <p-toggleButton class="form-control-togglebutton" formControlName="Activo"
                                                onLabel="Sí" offLabel="NO" onIcon="pi pi-check"
                                                offIcon="pi pi-times"></p-toggleButton>
                            </div>
                        </div>

                        <div class="row">

                            <div class="form-group col-md-12">
                                <label class="col-form-label required-field" for="inpDescripcion">Descripción</label>
                                <input formControlName="Descripcion" name="Descripcion" title="" class="form-control"
                                       maxlength="150" [ngClass]="displayFieldCss('Descripcion')" id="inpDescripcion" type="text" value="">

                                <div class="invalid-feedback" *ngIf="isFieldInvalid('Descripcion','required')">
                                    Descripción es obligatorio
                                </div>

                                <div class="invalid-feedback" *ngIf="isFieldInvalid('Descripcion','descripcion_duplicated')">
                                    Descripción ya existe
                                </div>
                            </div>
                        </div>

                        <div class="row">

                            <div class="form-group col-md-12">
                                <label class="col-form-label" for="inpDescripcionTraces">Descripción Traces</label>
                                <input formControlName="DescripcionTraces" name="DescripcionTraces" title="" class="form-control"
                                       maxlength="150" [ngClass]="displayFieldCss('DescripcionTraces')" id="inpDescripcionTraces" type="text" value="">
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>

</form>
